import { AgDonutSeriesTooltipRendererParams, AgTooltipRendererResult } from "ag-charts-community";

import { formatCurrency } from "fond/utils/currency";
import { formatFractionPercent } from "fond/utils/number";

interface CostTooltipRendererOptions {
  heading: string;
  formatValue?: (value: number) => string;
}

/**
 * Builds a tooltip renderer for a donut series whose datum has a `Key` and `TotalCost`,
 * showing the datum's formatted cost and its percentage share of `total`.
 */
export function createCostTooltipRenderer<T extends { Key: string; TotalCost: number }>(
  total: number,
  { heading, formatValue = (value) => formatCurrency(value, { notation: "compact" }) }: CostTooltipRendererOptions
) {
  return (params: AgDonutSeriesTooltipRendererParams<T>): AgTooltipRendererResult => {
    const percentage = formatFractionPercent(total > 0 ? params.datum.TotalCost / total : 0);
    return {
      heading,
      title: `${params.datum.Key}: ${formatValue(params.datum.TotalCost)} (${percentage} of total)`,
      data: [],
    };
  };
}
